import { Button } from '../../catalyst/button';
import { Dialog, DialogTitle, DialogDescription, DialogActions } from '../../catalyst/dialog';

interface DeleteConfirmDialogProps {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmDialog({ open, isPending, onClose, onConfirm }: DeleteConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Page</DialogTitle>
      <DialogDescription>Are you sure you want to delete this page? This action cannot be undone.</DialogDescription>
      <DialogActions>
        <Button plain onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
